export default "__VITE_ASSET__Bah9tZIQ__"